import ApiService from '@/services/api';
const API = new ApiService();
import { Storage } from "aws-amplify";
// import _ from 'lodash';

export const state = {
  auditSpaceList: [],
  auditSpaceTotalRows: 0,
  auditStoreInfo: null,
  auditStoreInfoSpaceRented: [],
  auditStoreStatus: null,
  auditShipStatus: null,
  auditTimeline: []
}

export const mutations = {
  SET_AUDIT_LIST(state, listings) {
    state.auditSpaceList = listings;
  },
  UPDATE_TOTAL_AUDIT(state, pageInfo){
    state.auditSpaceTotalRows = pageInfo;
  },
  UPDATE_STORE_INFO(state, info){
    state.auditStoreInfo = info;
  },
  async UPDATE_STORE_SPACE_RENTED(state, info){
    try {
      for(let i of info){
        if(i.photoSpace.length > 2 && !isValidHttpUrl(i.photoSpace)){
          i.photoSpace = await Storage.get(i.photoSpace, { level: "public" })
        }
      } 
    } catch (error) {
      console.log(">>> error po:", error);
    }
    state.auditStoreInfoSpaceRented = info;
  },
  UPDATE_STORE_SPACE_STATUS(state, info){
    state.auditStoreStatus = info;
  },
  UPDATE_STORE_SPACE_SHIP(state, info){
    state.auditShipStatus = info;
  },
  UPDATE_AUDIT_TIMELINE(state, timeline){
    state.auditTimeline = timeline;
  },
}

export const getters = {
}

export const actions = {
  fetchAuditSpaceList({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.post('/audit-space/list', params)
        .then(res => {
          commit('SET_AUDIT_LIST', res.message.rows);
          commit('UPDATE_TOTAL_AUDIT', res.message.pageInfo.total);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  fetchStoreInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      // console.log(">><<><>>>>> PARAMS",params);
      API.post('/audit-space/store-info', params)
        .then(res => {
          commit('UPDATE_STORE_INFO', res.message.store_details);
          commit('UPDATE_STORE_SPACE_RENTED', res.message.campaigns);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  fetchStoreSpaceInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.post('/audit-space/store-space-info', params)
        .then(res => {
          commit('UPDATE_STORE_SPACE_STATUS', res.message.storeStatus);
          commit('UPDATE_STORE_SPACE_SHIP', res.message.shipStatus);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  fetchStoreShipOut(context, params) {
    return new Promise((resolve, reject) => {
      API.post('/audit-space/ship-out', params)
        .then(res => {
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  fetchAuditSpaceLogs({ commit }, params) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_AUDIT_TIMELINE', []);
      API.post('/audit-space/logs', params)
        .then(async res => {
          try {
            console.log(">>>>>>>>>>>>>>>>> GETTING SIGN URL");
            for(let r of res.message.timelineData){
              var signedUrl = []
              for(let i of r.images){
                console.log(i,isValidHttpUrl(i));
                if(i.length > 2 && !isValidHttpUrl(i)){
                  signedUrl.push(await Storage.get(i, { level: "public" }));
                }else{
                  signedUrl.push(i);
                }
              }
              console.log(signedUrl);
              r.images = signedUrl
            }
            commit('UPDATE_AUDIT_TIMELINE', res.message.timelineData);
          } catch (error) {
            console.log(">>> error po sa timeline:", error);
          }
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  auditSpaceActionForm(context, params) {
    return new Promise((resolve, reject) => {
      API.post('/audit-space/action-form', params)
        .then(res => {
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  auditSpaceCronReleasePayment(context, params) {
    return new Promise((resolve, reject) => {
      API.post('/audit-space/cron-release-payment', params)
        .then(res => {
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
}



const isValidHttpUrl = function(string) {
  let url;
  
  try {
    url = new URL(string);
  } catch (_) {
    return false;  
  }

  return url.protocol === "http:" || url.protocol === "https:";
}